export default class StickyNav {
    constructor() {
        $(document).ready(() => {
            this.header = document.querySelector('.sticky-wrapper');
            this.stickyOffset = this.header.offsetHeight;

            this.initListeners();
        });
    }

    initListeners() {
        window.addEventListener('scroll', () => {
            this.pickClass(this.header);
        });
    }

    // Add or remove the sticky class based on winndow scroll position.
    pickClass(el) {
        if (window.pageYOffset > this.stickyOffset) {
            el.classList.add('stuck');
        } else {
            el.classList.remove('stuck');
        }
    }
}
